/** Book Now step (SelectTheater) — copy defaults */

export const bookingContentDefaults = {
  eyebrow: "",
  title: "Book Private Theater",
  subtitle: "Choose your perfect celebration venue",
  panelTitle: "Select Your Date & Theater",
  dateHelperNote: "",
  loadingTitle: "Loading theatres and slots…",
  loadingSubtitle: "Fetching availability for your selected date.",
  errorSubtitle: "Check your connection or try a different date.",
  emptyState: "No theatres available for this date. Please choose another date.",
  bookViaCallLabel: "Book via call",
};
